import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { Cover } from '../../music24/components/primitives/Cover';
import { addSongMessages } from './addSongMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole page; each part uses its own slice of it */
import styles from './AddSongView.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SongResultRowProps {
  id: string;
  title: string;
  subtitle?: string;
  imageUrl?: string;
  isPicked: boolean;
  disabled: boolean;
  /** Absent for a row that cannot be picked away (a pasted link). */
  onPick?: (id: string) => void;
}

/** One song in the results of "It is out" (design c1 `.ob-res .r`): cover, title, Pick or Picked. */
const SongResultRowComponent: React.FC<SongResultRowProps> = ({
  id,
  title,
  subtitle,
  imageUrl,
  isPicked,
  disabled,
  onPick,
}) => {
  const intl = useIntl();
  const pick = useCallback(() => onPick?.(id), [id, onPick]);

  return (
    <div className={clsx(styles.resultRow, isPicked && styles.resultRowOn)} data-testid="add-song-result">
      <Cover src={imageUrl} label={title} size={40} />
      <div className={styles.resultText}>
        <b>{title}</b>
        {subtitle !== undefined && subtitle !== '' && <small>{subtitle}</small>}
      </div>
      {isPicked ? (
        <span className={styles.pickedTag}>{intl.formatMessage(addSongMessages.picked)}</span>
      ) : (
        <button type="button" className={styles.linkButton} onClick={pick} disabled={disabled}>
          {intl.formatMessage(addSongMessages.pick)}
        </button>
      )}
    </div>
  );
};

export const SongResultRow = TypedMemo(SongResultRowComponent);
